import { CONFIGURATION_FLAGS } from './configurationFlags';

export default defineAppConfig({
  features: CONFIGURATION_FLAGS,
});
